/**
 * Stores a collection of unique lat/lon coordinates
 */
define(['jquery'], function ($) {
   "use strict";

   return function () {
      var self = this,
         m_aLocations = {};

      /**
       * Check whether the coordinates already exist in the store
       * @param {Number} lat
       * @param {Number} lon
       * @return {Boolean}
       */
      self.has = function (lat, lon) {
         var bHas = false;

         $.each(m_aLocations, function (i, loc) {
            if (loc.lat === lat) {
               if (loc.lon === lon) {
                  bHas = true;
                  return false;
               }
            }
         });

         return bHas;
      };

      /**
       * Add the specified coordinates to the store, if they
       * do not already exist
       * @param {Number} lat
       * @param {Number} lon
       * @return {Boolean} whether the coordinates were added
       */
      self.add = function (lat, lon) {
         if (!self.has(lat, lon)) {
            m_aLocations.push({
               lat: lat,
               lon: lon
            });

            return true;
         }

         return false;
      };

      /**
       * Clear all locations from the store
       */
      self.clear = function () {
         m_aLocations = [];
      };
   };
});
